/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_ErasureInputs */

const en_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to erasure`)
};

const de_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht auf Löschung`)
};

const fr_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit à l'effacement`)
};

const es_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho de supresión`)
};

const it_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto alla cancellazione`)
};

const nl_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht op vergetelheid`)
};

const pl_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo do usunięcia danych`)
};

const fi_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus tietojen poistamiseen`)
};

const da_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til sletning`)
};

const sv_privacy_rights_item_erasure = /** @type {(inputs: Privacy_Rights_Item_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt till radering`)
};

/**
* | output |
* | --- |
* | "Right to erasure" |
*
* @param {Privacy_Rights_Item_ErasureInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_erasure = /** @type {((inputs?: Privacy_Rights_Item_ErasureInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_ErasureInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_erasure(inputs)
	if (locale === "fr") return fr_privacy_rights_item_erasure(inputs)
	if (locale === "es") return es_privacy_rights_item_erasure(inputs)
	if (locale === "it") return it_privacy_rights_item_erasure(inputs)
	if (locale === "nl") return nl_privacy_rights_item_erasure(inputs)
	if (locale === "pl") return pl_privacy_rights_item_erasure(inputs)
	if (locale === "fi") return fi_privacy_rights_item_erasure(inputs)
	if (locale === "da") return da_privacy_rights_item_erasure(inputs)
	if (locale === "sv") return sv_privacy_rights_item_erasure(inputs)
	return en_privacy_rights_item_erasure(inputs)
});